import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { z } from 'zod';
import { createMagazineCategoryUseCase } from "../useCases/createMagazineCategoryUseCase";
import { toastService } from "src/libraries/toast";
import { useUiContext } from "src/UIProvider";

export const useMagazineCategoryCreating = () => {
    const { t } = useUiContext();
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ name: '', description: '' });
    const [magazineCategory, setMagazineCategory] = useState({ name: '', description: '' });
    const navigate = useNavigate();

    const magazineCategorySchema = z.object({
        name: z.string().min(1, { message: t('common.error.notEmpty') }),
        description: z.string().min(1, { message: t('common.error.notEmpty') }),
    });

    const onChange = (value: string, field: string) => {
        setMagazineCategory((prev) => ({ ...prev, [field]: value }));
        setErrors((prev) => ({ ...prev, [field]: '' }));
    };

    const onCreateMagazineCategory = async () => {
        setLoading(true);
        const result: any = magazineCategorySchema.safeParse(magazineCategory);
        if (result.success) {
            const response = await createMagazineCategoryUseCase(magazineCategory);
            if (!response?.isError) {
                toastService.onSuccess(t('magazineCategory.message.magazineCategoryCreated'));
                navigate(`/dashboard/magazine-categories`);
            }
        } else {
            result.error.errors.map((item: any) => {
                setErrors((prev) => ({ ...prev, [item.path[0]]: item.message }));
            });
        }
        setLoading(false);
    };

    return { magazineCategory, errors, onChange, onCreateMagazineCategory, loading };
};